<div class="p-a-xl cipo--overflow--auto cipo--height--full">
    <h2>Cipo Radio Group Fields</h2>

    <div fxLayout="row wrap" fxLayoutGap="12px">
        @for (control of form().controls | keyvalue; track $index) {
            <div fxFlex="30" fxFlexAlign="end" class="m-t">
                <cipo-control [control]="control.value" />
            </div>
        }
    </div>
</div>
